import React from 'react';
import PropTypes from 'prop-types';

import {
  Avatar,
  Heading,
  Icon,
  Text
} from 'components/common/Elements/Elements';
import CutIfToltip from '../Widgets/CutIfToltip/CutIfToltip';

import classes from './WidgetWithIcon.module.scss';

const WidgetWithIcon = ({ data = [] }) => {
  return (
    <section className={classes.widget}>
      <Heading>{data.titleWidget}</Heading>
      <div className={classes.wrapBobyWidget}>
        <div className={classes.iconWrap}>
          {data.icon && (
            <Icon size="24px" icon={data.icon} className={classes.icon} />
          )}
          {data.initials && (
            <Avatar
              initials={data.initials}
              initialsColor={'NA'}
              className={classes.avatar}
            />
          )}
        </div>
        <ul className={classes.infoWrap}>
          {data.info.map(
            info =>
              (!info.hiddenIfvalueMissing ||
                (info.hiddenIfvalueMissing &&
                  info.value !== '-' &&
                  info.value !== 'NA')) && (
                <li className={classes.cell} key={info.title}>
                  <Text className={classes.title}>
                    <CutIfToltip data={info.title} length={25} />
                  </Text>
                  {info.type ? (
                    <CutIfToltip
                      data={info.value}
                      text={info.textLink}
                      type={info.type}
                      length={0}
                    />
                  ) : (
                    <Text className={classes.description} weight="b">
                      {info.value}
                    </Text>
                  )}
                </li>
              )
          )}
        </ul>
      </div>
    </section>
  );
};

WidgetWithIcon.propTypes = {
  data: PropTypes.object
};

export default WidgetWithIcon;
